import { useEffect, useRef } from "react";

/**
 * 
 * Basiclly used to keep track of a previous value
 */

export function usePrevValue(val){
    const prevDataRef = useRef(null);
    useEffect(() => {
        prevDataRef.current = val;
    }, [val]);

    return prevDataRef.current;
}